// Components==============
import Dropdown from 'components/UI/Dropdown/Dropdown';
import { useRedux } from 'hooks/useRedux';
import React, { useContext, useEffect, useState } from 'react';
import { FilterType, TranslateType } from 'typings';
import { FilterContext } from '../../FilterMenu';
// =========================

export default function PublicationDropdown({
  initialText,
  id,
  extraOptions,
}: {
  initialText: TranslateType;
  id: number;
  extraOptions?: string[];
}) {
  const { setFilterValues, triggerReset } = useContext(FilterContext);
  const [selected, setSelected] = useState<string>('');

  const userOrganisation = useRedux(
    (state) => state?.authentication?.user.organisation.name
  );

  const options =
    extraOptions && userOrganisation ? [...extraOptions, userOrganisation] : [];

  useEffect(() => setSelected(''), [triggerReset]);

  useEffect(() => {
    setFilterValues(
      (prev) =>
        prev.map((val) =>
          val.id === id ? { ...val, value: selected } : val
        ) as FilterType[]
    );
  }, [selected]);

  return (
    <Dropdown
      initialText={initialText}
      selectedItem={selected}
      setSelectedItem={setSelected}
      initialOptions={options}
      translateOptions
      allowReset
    />
  );
}
